<loading-overlay>
    <dialog id="loading-overlay"
            aria-busy="true"
            aria-label="{state.loadingMessage || locale?.t('loading')}"
            class="loading-overlay-dialog print:hidden">
        <div class="flex flex-col items-center gap-4">
            <span class="loading loading-spinner loading-lg text-white" style="width: 50px; height: 50px"></span>
            <div style="font-size: 16px; color: #fff; font-weight: 500;">{state.loadingMessage}</div>
        </div>
    </dialog>

    <script>
        import { isPublicRoute } from '../config/routes.js';

        let hideTimer = null;
        const HIDE_DELAY = 200; // Delay before hiding overlay after requests complete

        export default {
            includeStore: true,

            state: {
                requests: 0,
                loadingMessage: ""
            },

            async onMounted() {
                this.$('dialog').addEventListener('cancel', (e) => e.preventDefault());

                this.updateState();

                this.unsubscribe = this.store.subscribe(() => {
                    this.updateState();
                });
            },

            show() {
                const dlg = this.$('dialog');
                if (!dlg || !dlg.isConnected || dlg.open) return;
                // On pre-auth public pages (login, forgot-password, etc.) open
                // the overlay NON-modally. A modal <dialog> enters the browser
                // top layer and inerts the background, which dismisses the
                // login page's WebAuthn conditional-mediation ("passkey
                // autofill") prompt — that popover is anchored to the login
                // input and dies the moment the input goes inert. Public pages
                // have little need for true block-UI (their forms guard their
                // own submit buttons), so a non-modal spinner is the safe
                // trade. Authenticated app pages keep full modal blocking.
                // (METALARK-973 regressed this when the overlay became a modal
                // <dialog>; METALARK-738 first surfaced the prompt-dismissal.)
                if (isPublicRoute(window.location.hash)) {
                    dlg.show();
                } else {
                    dlg.showModal();
                }
            },

            hide() {
                const dlg = this.$('dialog');
                if (dlg && dlg.open) dlg.close();
            },

            updateState() {
                const storeState = this.store.getState();

                this.state.requests = storeState.requests;
                this.state.loadingMessage = storeState.loadingMessage;

                // Handle overlay visibility with delay on hide
                if (this.state.requests > 0) {
                    // Requests active - show overlay immediately and cancel any hide timer
                    if (hideTimer) {
                        clearTimeout(hideTimer);
                        hideTimer = null;
                    }
                    this.show();
                } else {
                    // No active requests - delay hiding the overlay
                    const dlg = this.$('dialog');
                    if (dlg && dlg.open && !hideTimer) {
                        hideTimer = setTimeout(() => {
                            this.hide();
                            hideTimer = null;
                        }, HIDE_DELAY);
                    }
                }

                this.update();
            },

            onUnmounted() {
                if (hideTimer) {
                    clearTimeout(hideTimer);
                    hideTimer = null;
                }
                if (this.unsubscribe) {
                    this.unsubscribe();
                }
            }
        }

    </script>

    <style>
        .loading-overlay-dialog {
            width: 100vw;
            height: 100vh;
            max-width: 100vw;
            max-height: 100vh;
            margin: 0;
            padding: 0;
            border: none;
            background: transparent;
            overflow: hidden;
        }

        .loading-overlay-dialog[open] {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        @media print {
            .loading-overlay-dialog[open] {
                display: none;
            }
        }

        .loading-overlay-dialog::backdrop {
            background: rgba(0, 0, 0, 0.2);
        }
    </style>
</loading-overlay>
